import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import { Row, Col } from 'reactstrap';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { BasicMain, injectIntl } from 'components';
import { withTracker } from 'components/Tracker';
import immutableToJS from 'helpers/immutableToJS';
import { isMobile } from 'helpers/detect-mobile';
import { selectState } from 'redux/selectors';

import TeamMemberCard from './TeamMemberCard';


const styles = theme => ({
  actions: { textAlign: 'center', marginBottom: theme.spacing.unit * 5 },
  button: { margin: isMobile ? theme.spacing.unit / 4 : theme.spacing.unit },
  bottomSpacing: { marginBottom: theme.spacing.unit * 3 },
});

const Team = ({ classes, teamMembers, formatMessage }) => (
  <BasicMain>
    <Typography className={classes.bottomSpacing} variant="h4" align="center" color="textPrimary">
      {formatMessage('Team')}
    </Typography>
    <Typography className={classes.bottomSpacing} variant="subtitle2" align="center" color="textSecondary">
      {'FRESHr is a super organized and powerful team with smart and talented (or little crazy) people.'}
    </Typography>
    <Row className="team container">
      {teamMembers
        .map(teamMember => (
          <Col key={teamMember.name} xs="12" sm="6" md="4" lg="4" className={classes.bottomSpacing}>
            <TeamMemberCard
              member={teamMember}
              formatMessage={formatMessage}
            />
          </Col>
        ))
      }
    </Row>
  </BasicMain>
);

Team.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  teamMembers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  formatMessage: PropTypes.func.isRequired,
};

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('options', 'teamMembers')(state),
});

export default compose(
  setDisplayName('Team'),
  connect(
    mapStateToProps,
  ),
  injectIntl,
  immutableToJS,
  withStyles(styles),
  withTracker,
)(Team);
